module.exports = __webpack_public_path__ + "media/bootstrap-icons/dice-1-fill-1f557171.svg";